"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadPhoto = void 0;
const commands_1 = require("../models/commands");
const uuid_1 = require("uuid");
const interfaces_1 = require("../models/interfaces");
class UploadPhoto extends interfaces_1.CommandBase {
    constructor(cmd) {
        cmd.photoId = cmd.photoId || (0, uuid_1.v4)();
        cmd.translationId = cmd.translationId || (0, uuid_1.v4)();
        cmd.photoPublishPolicy = cmd.photoPublishPolicy || "SystemDefault";
        if (!cmd.translationInfo) {
            cmd.translationInfo = {
                culture: "nd-nd",
            };
        }
        cmd.translationInfo.platform = cmd.translationInfo.platform || "default";
        super(commands_1.Command.UploadPhoto, cmd);
    }
}
exports.UploadPhoto = UploadPhoto;
//# sourceMappingURL=uploadPhoto.js.map